import { Box, Typography, Button } from '@mui/material';
import { useTranslation } from '../../../i18n/useTranslation';

type WelcomeResetBannerProps = {
    onResetClick: () => void;
    showProcurementNotice?: boolean;
};

export default function WelcomeResetBanner({ onResetClick, showProcurementNotice = false }: WelcomeResetBannerProps) {
    const { t } = useTranslation('translation');

    return (
        <Box
            sx={{
                backgroundColor: '#f2f2f2',
                p: 4,
                maxWidth: 900,
                mx: 'auto',
                mt: 5,
                color: '#d32f2f',
            }}
        >
            <Typography fontWeight="bold" mb={2}>
                {t('loginForm.WELCOME_RESET_BANNER.TITLE')}
            </Typography>

            <Typography mb={2}>
                {t('loginForm.WELCOME_RESET_BANNER.DESCRIPTION_1')}
                <br />
                {t('loginForm.WELCOME_RESET_BANNER.DESCRIPTION_2')}
                <br />
                {t('loginForm.WELCOME_RESET_BANNER.DESCRIPTION_3')}
            </Typography>

            <Typography mb={2}>{t('loginForm.WELCOME_RESET_BANNER.RESET_INFO')}</Typography>

            {showProcurementNotice && (
                <Typography fontWeight="bold" mb={2}>
                    {t('loginForm.WELCOME_RESET_BANNER.PROCUREMENT_NOTICE')}
                </Typography>
            )}

            <Button
                variant="outlined"
                onClick={onResetClick}
                sx={{
                    borderColor: '#d32f2f',
                    color: '#1976d2',
                    textTransform: 'none',
                    mb: 2,
                    '&:hover': {
                        backgroundColor: '#ffe6e6',
                        borderColor: '#d32f2f',
                    },
                }}
            >
                {t('loginForm.WELCOME_RESET_BANNER.RESET_BUTTON')}
            </Button>

            <Typography>{t('loginForm.WELCOME_RESET_BANNER.LOGIN_INFO')}</Typography>
        </Box>
    );
}
